import React from 'react';

const ReviewButton = ({ text, onClick = () => { } }) => {
  return (
    <div className="border border-[#808080] rounded-2xl px-4 py-1 flex justify-center items-center" onClick={onClick}>
      <span className="text-[#808080] text-sm">
        {text}
      </span>
    </div>
  )
}

export default ReviewButton;